'use client';
import cx from 'clsx';
import React from 'react';
import { Box, getRadius, rem } from '@mantine/core';
import classes from '../flagpack.module.css.mjs';

function PWFlag({ radius, className, size, ...others }) {
  return /* @__PURE__ */ React.createElement(
    Box,
    {
      className: cx(classes.flag, className),
      __vars: { "--flag-radius": getRadius(radius), "--flag-size": rem(size) },
      ...others
    },
    /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 24" }, /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("mask", { id: "mantine-wcrqzqxss", fill: "#fff" }, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", d: "M0 0h32v24H0z" })), /* @__PURE__ */ React.createElement("mask", { id: "mantine-97q4vr69s", fill: "#fff" }, /* @__PURE__ */ React.createElement("use", { fillRule: "evenodd", xlinkHref: "#mantine-c4civtd7u" })), /* @__PURE__ */ React.createElement("path", { id: "mantine-c4civtd7u", d: "M0 0h32v24H0z" })), /* @__PURE__ */ React.createElement("g", { fill: "none", fillRule: "evenodd", mask: "url(#mantine-wcrqzqxss)" }, /* @__PURE__ */ React.createElement("use", { fill: "#61c6f0", xlinkHref: "#mantine-c4civtd7u" }), /* @__PURE__ */ React.createElement("circle", { cx: "11.5", cy: "11.5", r: "6.5", fill: "#fbcd17", mask: "url(#mantine-97q4vr69s)" })))
  );
}

export { PWFlag };
//# sourceMappingURL=PW.mjs.map
